import toast from "@/lib/toast";
import { saveAs } from "file-saver"

const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

export const saveAsExcelFile = (response: any, defaultFileName: string = "download", isDefaultName: boolean = false) => {
    try {
        const data = new Blob([response.data], {
            type: EXCEL_TYPE
        });

        const disposition = response.headers?.["content-disposition"];

        let fileName = defaultFileName;

        if (disposition) {
            const fileNameMatch = disposition.match(/filename="?([^"]+)"?/);
            if (fileNameMatch?.[1]) {
                fileName = fileNameMatch[1];
            }
        }

        saveAs(data, isDefaultName ? defaultFileName : fileName);
    } catch (err : any) {
        toast.error(err);
    }
};